import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import UNIVERSAL from "../config/config";

const initialState = {
  data: "",
  loading: false,
  error: "",
};

export const fetchBusiness = createAsyncThunk("business/fetchBusiness", (data) => {
  return fetch(UNIVERSAL.BASEURL_1 + `/biz/getBiz`, {
    method: "POST",
    headers: {
      "x-api-key": "6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe",
    },
    body: JSON.stringify({
      businessId: data.businessId,
    }),
  })
    .then((response) => response.json())
    .then((res) => {
      return res.data;
    });
});

const fetchBusinessSlice = createSlice({
  name: "business",
  initialState,

  extraReducers: (builder) => {
    builder.addCase(fetchBusiness.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchBusiness.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = "";
    });
    builder.addCase(fetchBusiness.rejected, (state, action) => {
      state.loading = false;
      state.data = "";
      state.error = action.error.message;
    });
  },
});

export default fetchBusinessSlice;
